<template>
<div class="bottom-widget" v-if="activeList.value" ref="widget">
  <a href="" @click.prevent="toggleWidget" class="minimizeMaximizeBtn" :class="{minimized: minimize}">{{ minimize ? '+ Maximize' : "- Minimize"}}</a>
  <div class="text-right">
    <a href="" @click.prevent="exitList" class="text-danger">Exit List Mode</a>
  </div>
  <a href="" @click.prevent="loadList" class="loadListBtn">Load list data</a>
  <h3>Active Orders List Details</h3>
  <b-row>
    <b-col cols="12">
      <b-list-group>
        <b-list-group-item>
          <strong class="text-primary">Active List:</strong> <span v-if="!editMode">{{ activeList.name }}</span>
          <div v-if="editMode">
            <b-form-input v-model="listName" class="m-b-10" ></b-form-input>
             <div class="clearfix">
                <b-button variant="success" size="xs"  class="float-right" @click="updateList()">Update</b-button>
                <b-button variant="danger" @click="editMode=false" size="xs" class="float-right m-r-10">Cancel</b-button>
             </div>
          </div>
        <!-- Dropdown -->
        <div>
          <b-dropdown id="dropdown-dropleft" dropleft text="List Actions" variant="dark"  size="xs">
            <b-dropdown-item href="#" @click.prevent="editMode = true">Edit List</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="deleteList">Delete List</b-dropdown-item>
          </b-dropdown>
        </div>


        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center"><strong class="text-primary">
          <a href="" v-if="forAddingArray.length > 0" @click.prevent="removeTemp('add')" class="text-danger" ><b-icon icon="arrow-counterclockwise"></b-icon></a>
          Ready to add to list:</strong>
          <b-badge variant="primary" pill>{{ forAddingArray.length }}</b-badge>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center"><strong class="text-primary">
            <a href="" class="text-danger" v-if="forRemovalArray.length > 0" @click.prevent="removeTemp('remove')"><b-icon icon="arrow-counterclockwise"></b-icon></a> 
            Ready to remove from list:
          </strong>
          <b-badge variant="danger" pill>{{ forRemovalArray.length }}</b-badge>
        </b-list-group-item>
      </b-list-group>
      <h4 class="m-t-30">Orders in list ({{ordersInList.length}})</h4>
      <div class="m-b-20">
        <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
          <ul class="listOfOrders">
            <li v-for="order in ordersInList" v-bind:key="order.id">
              {{ order.orderNo }} <a href="#" @click.prevent="removeFromList(order.id)" class="removeBtn"><b-icon icon="x-square" font-scale="1"></b-icon></a>
            </li>
          </ul>
        </vue-custom-scrollbar>
      </div>
    </b-col>
    <b-col cols="12">
      <b-button size="lg" class="mb-2" variant="primary" block @click="commitAction" :disabled="(forAddingArray.length == 0 && forRemovalArray.length == 0) || inProgress">
        <b-icon icon="cloud-upload" aria-hidden="true" v-if="!inProgress"></b-icon> 
        <b-spinner small type="grow" v-if="inProgress"></b-spinner>
        Commit Changes
      </b-button>
    </b-col>
  </b-row>
</div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import EventBus from '../../../EventBus'
import OrdersListService from '../../../services/orders-list.service'
import Vue from 'vue'
export default {
  data() {
    return {
      listName: "",
      editMode: false,
      minimize: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      }
    }
  },
  components: {
    vueCustomScrollbar
  },
  watch: {
    activeList(newValue){
       this.listName = newValue.name
    }
  },
  methods: {
    async commitAction() {
      await this.$store.dispatch('ordersList/commitToDatabase')
    },
    toggleWidget() {
      this.minimize = !this.minimize;
      const widgetRef = this.$refs.widget;
      if (this.minimize) {
        const height = widgetRef.offsetHeight;
        console.log(height);
        widgetRef.style.bottom = `-${height}px`;
      } else {
        widgetRef.style.bottom = `0px`;
      }
    },
    scrollHanle(evt) {
      console.log(evt)
    },
    removeFromList(orderId) {
      this.$store.dispatch("ordersList/addToTempOrderIdsForRemoval", orderId)
    },
    removeTemp(type){
      this.$store.dispatch("ordersList/emptyTemporaryList", type)
    },
    exitList(){
      this.$store.dispatch("ordersList/exitListMode")
      EventBus.$emit('exited-list')
    },
    loadList(){
      EventBus.$emit("load-list-data", this.activeList.value)
    },
    async updateList(){
      if(!this.listName){
         this.$toasted.show(
          "A list name is required",
          {
            type: "error",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 2000
          }
        );
        this.listName = this.activeList.name
      }else{
         const updatestatus = await OrdersListService.editOrderList({name: this.listName}, this.activeList.value); 

         this.$toasted.show(
          "List updated successfully",
          {
            type: "success",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 2000
          }
        );
        this.editMode = false
        // update name in store
        this.$store.dispatch("ordersList/addOrRemoveActiveList", {
           action: 'add', 
           orderList: {
             value: this.activeList.value,
             name: this.listName
           }
        })

      }
    },
   deleteList(){
      let that = this;

      Vue.dialog
      .confirm(`Are you sure you want to delete list? It's irreversible.`)
      .then(async function(dialog) {
        try{
          await OrdersListService.deleteOrdersList(that.activeList.value);
          that.$toasted.show(
          "List deleted successfully",
          {
            type: "success",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 2000
          }
        );
         that.$store.dispatch('ordersList/exitListMode');
         EventBus.$emit('exited-list')
        }
        catch(e){
          console.log("Error while deleting list", e)

          if(e.response.status == 403){
            that.$toasted.show(
                 e.response.data.message,
                {
                  type: "error",
                  action: {
                    text: "Close",
                    class: "toastBtnTxt",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                  duration: 2000
                })
          }
        }
      })
      .catch(function() {
        console.log('Clicked on cancel');
      });
    }
  },
  computed: {
    activeList() {
      return this.$store.state.ordersList.activeList
    },
    forAddingArray() {
      return this.$store.state.ordersList.temporaryIdsForAdding
    },
    forRemovalArray() {
      return this.$store.state.ordersList.temporaryIdsForRemoving
    },
    ordersInList() {
      return this.$store.state.ordersList.idsOfOrdersInList;
    },
    inProgress(){
      return this.$store.state.ordersList.inProgress
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-widget {
  position: fixed;
  bottom: 0;
  right: 10px;
  width: 500px;
  background-color: rgb(243, 243, 243);
  padding: 30px 30px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2), -2px -2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  border-radius: 5px 5px 0 0;
  transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
  transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.listOfOrders {
  list-style-type: none;
  padding-left: 0;

  li {
    display: inline-block;
    padding: 5px 10px;
    background-color: rgb(236, 255, 235);
    color: rgb(36, 185, 22);
    border: 1px solid rgb(41, 231, 24);
    font-size: 12px;
    border-radius: 5px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}

.minimizeMaximizeBtn {
  position: absolute;
  top: -30px;
  left: 20px;
  display: inline-block;
  background-color: rgb(248, 68, 68);

  color: #fff;
  padding: 5px 10px;
  border-radius: 5px 5px 0 0;
  font-size: 12px;
  height: 30px;
  text-decoration: none;

  &.minimized {
    background-color: rgb(130, 224, 22);
  }
}
.loadListBtn{
  position: absolute;
  top: -30px;
  left: 110px;
  display: inline-block;
  background-color: rgb(68, 146, 248);

  color: #fff;
  padding: 5px 10px;
  border-radius: 5px 5px 0 0;
  font-size: 12px;
  height: 30px;
  text-decoration: none;
}
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100px;
}
a.removeBtn{
   text-decoration: none;
   color: rgb(241, 56, 56);
   margin-left: 5px;
   display: inline-block;
   transition: all 300ms ease;
   &:hover{
     transform: scale(1.2);
   }
}
</style>
